/**
 * Backdrop Component
 *
 * The theatrical drop image that descends from above.
 * Applies animation classes based on the current phase.
 */

import React from "react";
import { AnimationPhase, ASSETS } from "./constants";
import styles from "./WelcomeAnimation.module.css";

interface BackdropProps {
  phase: AnimationPhase;
}

export function Backdrop({ phase }: BackdropProps) {
  // Determine CSS class based on phase
  const phaseClass = styles[phase] || "";

  return (
    <div className={`${styles.backdrop} ${phaseClass}`}>
      <img
        src={ASSETS.BACKDROP}
        alt="Welcome to Stagecraft - Open Alpha. We are building a collaborative CAD platform for live entertainment."
        draggable={false}
      />
    </div>
  );
}
